export default __webpack_public_path__ + "static/char-s-38-ja-c0e8f00855cd39dfb06fdd5bd946aa91.webp";